import React, { useContext } from "react";
import classes from "./Footer.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEarthAmericas } from "@fortawesome/free-solid-svg-icons";
import { faTwitter, faFacebookF } from "@fortawesome/free-brands-svg-icons";
import sustainableLogoText from "../../assets/Sustainable-Dundee.svg";
import blue2Logo from "../../assets/blue2-logo.png";
import GoalContext from "../../store/goal-context";

const Footer = (props) => {
  const goalContext = useContext(GoalContext);
  const settings = goalContext.settings;

  return (
    <footer className={classes.footer}>
      <div className={classes.wrapper}>
      <div className={classes.logo}>
        <img src={sustainableLogoText} alt="Sustainable Dundee Logo" />
      </div>
      <div className={classes["menu-wrapper"]}>
        <div className={classes["menus"]}>
          <ul className={classes.menu}>
            {settings.events_link && (
              <li>
                <a href={settings.events_link} target="_blank"  rel="noopener noreferrer">
                  Events
                </a>
              </li>
            )}
            {settings.feedback_link && (
              <li>
                <a href={settings.feedback_link} target="_blank"  rel="noopener noreferrer">
                  Feedback
                </a>
              </li>
            )}
          </ul>
          <ul className={classes.socials}>
            {settings.facebook_link && (
              <li>
                <a href={settings.facebook_link} target="_blank"  rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
              </li>
            )}
            {settings.twitter_link && (
              <li>
                <a href={settings.twitter_link} target="_blank"  rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
              </li>
            )}
            {settings.website_link && (
              <li>
                <a href={settings.website_link} target="_blank"  rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faEarthAmericas} />
                </a>
              </li>
            )}
          </ul>
        </div>
        <div className={classes["powered-by"]}>Powered by<br/><a href="https://blue2.co.uk/" target="_blank"  rel="noopener noreferrer">Blue2</a></div>
      </div>
      <div className={classes.websiteBy}>
        <p>Powered by</p>
        <a href="https://blue2.co.uk/" rel="noopener noreferrer">
          <img src={blue2Logo} alt="Blue2" />
        </a>
      </div>
      </div>
    </footer>
  );
};

export default Footer;
